import { render, staticRenderFns } from "./ForceEditDialog.vue?vue&type=template&id=48e5fe5e&"
import script from "./ForceEditDialog.vue?vue&type=script&lang=js&"
export * from "./ForceEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports